// Whether the arrival welcome (`DemoWelcome.tsx`) has already been dismissed for a given
// plan — `localStorage`, keyed per plan, the same per-viewer convenience
// `release-notes-seen.ts` already keeps for the account menu's dot. A person who clears
// their browser, or opens the plan somewhere new, sees the welcome again; that is fine —
// it is not a fact the server needs to know, and it must never block the conversation
// behind it, so a store that refuses to remember reads as "not seen yet" on the way in
// and is simply not written on the way out.

const KEY_PREFIX = 'mor.demo.welcomeSeen.';

export function demoWelcomeSeen(planId: string): boolean {
  try {
    return window.localStorage.getItem(KEY_PREFIX + planId) !== null;
  } catch {
    return false;
  }
}

export function markDemoWelcomeSeen(planId: string): void {
  try {
    window.localStorage.setItem(KEY_PREFIX + planId, '1');
  } catch {
    // The dismissal still closes the dialog for this view — see `DemoWelcome.tsx` — it
    // just will not stick for next time.
  }
}
